module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    class: {
      online: _vm.online
    },
    attrs: {
      "id": "app",
      "light": ""
    }
  }, [_c('main', [_c('router-link', {
    staticClass: "home-link",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/weview_rond.png"),
      "alt": "Vue.js PWA"
    }
  })]), _vm._v(" "), _c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 325
// module chunks = 1